/*
 * @Description:
 * @Date: 2022-12-01 10:50:37
 */

import { previewBill } from '@/utils/download';
import {
  BaseButton,
  BaseTableColumnProps,
  BaseTextContent,
  createDialog
  // XrkTableRef
} from 'xrk-components';
import { date, money } from 'xrk-tools';
import { PaymentAmount } from '../compoenents';
import { download } from 'xrk-tools';
import { batchDownloadReceipt } from '../data-source/apis';
import { formatter } from '@/utils';
import { dealParam } from './use-event';

const index: BaseTableColumnProps = {
  type: 'index',
  label: '序号',
  width: 60
};

const projectName: BaseTableColumnProps = {
  prop: 'projectName',
  label: '项目名称',
  minWidth: '300px'
};

const serviceFirm: BaseTableColumnProps = {
  prop: 'csoEntName',
  label: '服务商企业',
  minWidth: '300px'
};

const orderCreatDt: BaseTableColumnProps = {
  prop: 'payDt',
  label: '支付时间',
  minWidth: '180px',
  formatter: ({ cellValue }) => (cellValue ? date.dateFormat(cellValue) : '-')
};

const completeNum: BaseTableColumnProps = {
  prop: 'finishSum',
  label: '实际完成任务量'
};
const finallyPrice: BaseTableColumnProps = {
  prop: 'taskPrice',
  label: '终端结算单价',
  formatter: ({ cellValue, row }) =>
    row.projectType == 19 ? '-' : money.moneyFixed(cellValue)
};
const finallyPriceSum: BaseTableColumnProps = {
  prop: 'taskPriceSum',
  label: '终端结算金额',
  formatter: ({ cellValue }) => money.moneyFixed(cellValue || 0)
};

const payStatus: BaseTableColumnProps = {
  prop: 'payStatus',
  label: '支付状态',
  render() {
    return <span>支付成功</span>;
  }
};

// 按项目展示
export const projectTableColumn = [
  index,
  projectName,
  serviceFirm,
  completeNum,
  finallyPrice,
  finallyPriceSum,
  {
    label: '已结算人数',
    prop: 'peopleCount',
    render({ row }) {
      const { orderType, orderId, projectId } = row;
      return (
        <div style="display:flex; align-items:center;">
          <span style="margin-right:15px">{row.peopleCount}</span>
          <BaseButton
            type="text"
            onClick={() => {
              createDialog({
                title: '结算用户',
                width: 950,
                cancelBtnConfig: {
                  show: false
                },
                contentRender: () => (
                  <BaseTextContent>
                    <PaymentAmount param={{ orderType, orderId, projectId }} />
                  </BaseTextContent>
                )
              });
            }}
          >
            详情
          </BaseButton>
        </div>
      );
    }
  },
  payStatus,
  orderCreatDt,
  {
    label: '操作',
    width: 120,
    render({ row }) {
      async function toCenterDownLoad() {
        const fileName = `电子回单_${formatter.date(Date.now(), 'YYYYMMDD')}`;
        await batchDownloadReceipt({
          fileName: decodeURIComponent(fileName),
          downloadType: 801,
          queryParam: JSON.stringify(
            dealParam({
              orderId: row.customOrderId
            })
          )
        });
      }
      return (
        <>
          <BaseButton
            v-resource={[['下载回单']]}
            onClick={() => {
              toCenterDownLoad();
            }}
            type="text"
          >
            下载回单
          </BaseButton>
        </>
      );
    }
  }
];
// 按人展示
export const personTableColumn = [
  index,
  {
    label: '项目参与人',
    prop: 'fullName'
  },
  {
    label: '手机号',
    prop: 'phone'
  },
  projectName,
  serviceFirm,
  completeNum,
  finallyPrice,
  finallyPriceSum,
  payStatus,
  orderCreatDt,
  {
    label: '操作',
    width: 200,
    render({ row }) {
      return (
        <>
          <BaseButton
            disabled={!row.bankPayVoucherUrl || row.bankPayVoucherUrl === '-'}
            onClick={() => {
              previewBill(row.bankPayVoucherUrl);
            }}
            type="text"
          >
            查看
          </BaseButton>
          <BaseButton
            v-resource={[['下载回单']]}
            disabled={!row.bankPayVoucherUrl || row.bankPayVoucherUrl === '-'}
            onClick={() => {
              download.downloadFile(row.bankPayVoucherUrl, {
                fileName: row.receiptName,
                useResponseFileName: false
              });
            }}
            type="text"
          >
            下载回单
          </BaseButton>
        </>
      );
    }
  }
];
